module.exports = __webpack_public_path__ + "img/icon-sb-returns-boutique-48.9b2551c.svg";